import moment from 'moment';

const columnOverrides = [
  {
    field: 'inivalid',
    valueGetter: ({ value }) => value && moment(value).format('DD/MM/YYYY'),
  },
  {
    field: 'fimvalid',
    valueGetter: ({ value }) => value && moment(value).format('DD/MM/YYYY'),
  },
];

export default columnOverrides;
